module.exports = __webpack_public_path__ + "../resources/img/ic_re_air_conditioner_default.ae160bc8.svg";